import { render, staticRenderFns } from "./ReviewSave.vue?vue&type=template&id=18da7d6c"
import script from "./ReviewSave.vue?vue&type=script&lang=js"
export * from "./ReviewSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports